<template>
    <span class="text-danger" v-if="mostrarBtnExcluir">
        <i
            class="fa fa-trash fa-lg icon-button ml-1"
            title="Excluir Comprometimento"
            @click.stop="confirmarExcluir()"
        ></i>
    </span>
</template>

<script>
import { comprometimentoStatus } from '../ComprometimentoStatus'

export default {
    props: {
        entrega: {
            type: Object,
            default: () => ({})
        },

        movimentosServicos: {
            type: Object,
            required: true,
            default: () => ({})
        }
    },

    data() {
        return {}
    },

    methods: {
        confirmarExcluir() {
            this.$swal({
                title: 'Exclusão de Comprometimento',
                html: `Confirma a exclusão do comprometimento de ID <b>${this.entrega.idRm}</b>?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then(result => {
                if (result.value) {
                    this.excluir()
                }
            })
        },

        excluir() {
            this.$store.dispatch('addRequest')
            this.movimentosServicos
                .excluirComprometimentoEntrega(this.entrega.entregaId)
                .then(response => {
                    if (response) {
                        if (response.success) {
                            this.$toast.success(
                                'Registro excluído com sucesso!',
                                'OK',
                                this.$toastConfig.success
                            )
                            this.$emit('obterAtualizacao')
                        } else {
                            this.$toast.error(
                                'Erro ao excluir comprometimento.',
                                'ERROR',
                                this.$toastConfig.error
                            )
                        }
                    }
                    this.$store.dispatch('removeRequest')
                })
        }
    },

    computed: {
        mostrarBtnExcluir() {
            return (
                this.$temAcesso('CRED-UABS-ENTR-02') &&
                this.entrega.statusFinIdRm != 'F' &&
                (this.entrega.statusIdRm ===
                    comprometimentoStatus.COMPROMETIDO ||
                    this.entrega.statusIdRm ===
                        comprometimentoStatus.ATUALIZAR_COMPROMETIMENTO ||
                    (this.entrega.statusIdRm === comprometimentoStatus.ERRO &&
                        this.entrega.idRm))
            )
        }
    }
}
</script>
